import styled from 'styled-components';

import CommonComponentStyle from 'commons/styles/basic-components.styles';

class DNDetailPageStyles extends CommonComponentStyle {
  PageWrapper = styled.div`
    padding: 16px 12px;
  `;

  CardTopRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
  `;

  PrintButton = styled(this.PrimaryButton)`
    width: auto !important;
    padding: 8px 20px !important;
    text-transform: none !important;
    font-size: 14px !important;
  `;

  StatusRow = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    font-weight: 500;
    color: #374151;
  `;

  StatusBadge = styled.span<{ $bg: string; $color: string }>`
    display: inline-block;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.3px;
    white-space: nowrap;
    background-color: ${({ $bg }) => $bg};
    color: ${({ $color }) => $color};
  `;

  InfoSection = styled.div`
    border: 1px solid ${this.colors.LIGHT_GRAY};
    border-radius: 4px;
    padding: 12px 16px;
    margin-bottom: 8px;
  `;

  InfoLabel = styled.span`
    font-size: 12px;
    font-weight: 700;
    color: #374151;
    margin-bottom: 4px;
  `;

  InfoValue = styled.span`
    font-size: 13px;
    color: #111827;
  `;

  TableWrapper = styled.div`
    overflow-x: auto;
    margin-top: 12px;
  `;

  StyledTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
  `;

  TableHeaderCell = styled.th`
    border: 1px solid #d1d5db;
    padding: 8px 10px;
    text-align: center;
    font-size: 13px;
    font-weight: 600;
    background: #f9fafb;
    white-space: nowrap;
  `;

  TableBodyCell = styled.td`
    border: 1px solid #d1d5db;
    padding: 8px 10px;
    font-size: 13px;
    text-align: center;
    vertical-align: top;
  `;
}

const S = new DNDetailPageStyles();
export default S;
